import React, { useEffect, useState } from "react";
import { Field } from "formik";
import {
  FieldButtonGroup,
  FieldInput,
  FieldInputNumber,
} from "../../../components";
import { required, typeSetting } from "../../../utils";
import { manageMapperStore } from "../../../contexts";
import { useContext } from "react";
import { get } from "lodash";

const TargetTypeSettings = (props) => {
  const {
    fields,
    values,
    setFieldValue,
    handleChange,
    disabledKeys,
    setDisabledKeys,
    index,
    mappedData,
    fieldIndex,
  } = props;

  const { dispatch, state } = useContext(manageMapperStore);
  const data = get(state, "api.data", {});
  const recordLength = get(data, "recordLength");

  const handlePress = (event) => {
    if (event.key == "Enter") {
      event.preventDefault();
      document.getElementById("saveonEnter").click();
    }
  };
  const [filterTypeSetting, setFilterTypeSetting] = useState([]);

  useEffect(() => {
    var isHeader = mappedData
      .filter((_, ind) => ind == index)
      .some((_) => _.sectionType === 0);
    var isTrailer = mappedData
      ?.filter((_, ind) => ind == index)
      .some((_) => _.sectionType === 2);
    if (isHeader || isTrailer) {
      // setDisabledKeys(["Key"]);
      setFilterTypeSetting(
        typeSetting.filter((obj) => {
          return obj.label !== "Key";
        })
      );
    } else {
      setFilterTypeSetting(typeSetting);
    }
  }, [mappedData, typeSetting]);

  return (
    <div style={{ marginTop: "3rem", marginLeft: "1rem" }}>
      <Field
        isRequired
        name={fields.typeSetting}
        label="Select"
        size="smdd"
        options={filterTypeSetting}
        selectedValue={values[fields.typeSetting]}
        onChange={(value) => {
          setFieldValue(fields.typeSetting, value);
        }}
        disabledValues={disabledKeys}
        validate={required}
        component={FieldButtonGroup}
      />
      <div className={`d-flex align-items-baseline w-100 marg-top-15 `}>
        <Field
          size="xs"
          isRequired
          className="w-80 marg-right-20 "
          name={fields.from}
          placeHolder="Starts"
          label="From"
          type="text"
          autoComplete="off"
          value={values[fields.from]}
          onChange={handleChange}
          min={1}
          max={999999999}
          component={FieldInputNumber}
          validate={(value) => {
            if (!value) return "Required";
            if (value > parseInt(recordLength))
              return "Value should be less than Record Length";
            if (value > values[fields.to]) return "Invalid";
            var flag = false;
            mappedData[index].fixedWidthOutputSectionFields.forEach((x, i) => {
              if (i == fieldIndex) return;
              else if (x.to >= value && value >= x.from) flag = true;
            });
            if (flag) return "Invalid";
            return undefined;
          }}
        />

        <Field
          size="xs"
          isRequired
          name={fields.to}
          placeHolder="Ends"
          label="To"
          type="text"
          autoComplete="off"
          value={values[fields.to]}
          onChange={handleChange}
          min={1}
          max={999999999}
          component={FieldInputNumber}
          validate={(value) => {
            if (!value) return "Required";
            if (value > parseInt(recordLength))
              return "Value should be less than Record Length";
            if (value < values[fields.from]) return "Invalid";
            var flag = false;
            mappedData[index].fixedWidthOutputSectionFields.forEach((x, i) => {
              if (i == fieldIndex) return;
              else if (x.to >= value && value >= x.from) flag = true;
            });
            if (flag) return "Invalid";
            return undefined;
          }}
        />
      </div>
      <Field
        label="Enter Header"
        name={fields.fieldName}
        type="text"
        size="smd"
        autoComplete="nope"
        value={values[fields.fieldName]}
        onChange={(evt) => {
          setFieldValue(fields.fieldName, evt.target.value);
        }}
        onKeyPress={handlePress}
        component={FieldInput}
      />
    </div>
  );
};

export default TargetTypeSettings;
